import { IModuleConfig, MenuKind } from '@simac/ui';

export const SspManagerModuleConfig: IModuleConfig = {
  name: 'sspmanager',
  routing: {
    menuKind: MenuKind.None,
    route: '',
    children: [],
  },
  injects: [
    {
      name: 'library',
      components: [
        {
          name: 'Ssp project',
          icon: 'far fa-diagram-project',
          translateLabel: 'SSP.PROJECT.TITLE',
          permission: 'Module.ServiceAndSupport.Project.View',
          pages: [
            {
              isDefault: true,
              route: 'project',
              loadComponent: () => import('../components/project/project.component').then((m) => m.SspProjectComponent),
            },
            {
              isDefault: false,
              route: 'project/:id',
              loadComponent: () => import('../components/project/project-details.component').then((m) => m.SspProjectDetailsComponent),
            },
          ],
        },
        {
          name: 'Ssp manager flexy',
          icon: 'far fa-swatchbook',
          translateLabel: 'SSP.MANAGEMENT.FLEXY',
          permission: 'Module.ServiceAndSupport.Flexy.View',
          pages: [
            {
              isDefault: true,
              route: 'flexy',
              loadComponent: () => import('../components/flexy/flexy.component').then((m) => m.FlexyComponent),
            },
          ],
        },
      ],
    },
  ],
};
